import { CapabilityKey, EMPTY_AVATAR_IMAGE_GENERATION_CONFIG } from "@next-platform/packages-ts-types";
import { useApplicationCapabilitiesAllowed } from "../../infra/application/capabilities/hooks/useApplicationCapabilitiesAllowed";
import basicAppConfig from "../../infra/constants/basicAppConfig";
import { useAppDispatch, useAppSelector } from "../hook";
import { setApplicationId, setIsPartner } from "./appSlice";
const getTagOptions = (sfwTags, nsfwTags, priorityTags) => {
    const allTagsWithPriorityTags = [...nsfwTags, ...sfwTags];
    const allTagsWithoutPriorityTags = allTagsWithPriorityTags.filter((tag) => !priorityTags.includes(tag));
    allTagsWithoutPriorityTags.sort();
    return [...priorityTags, ...allTagsWithoutPriorityTags];
};
export default function useApp() {
    const dispatch = useAppDispatch();
    const appSettings = useAppSelector((state) => state.app.appSettings);
    const lastAppSettingUpdatedAt = useAppSelector((state) => state.app.lastAppSettingUpdatedAt);
    const app = useAppSelector((state) => state.app);
    const isPartner = useAppSelector((state) => state.app.isPartner);
    const deviceType = useAppSelector((state) => state.app.deviceType);
    const staticApplicationId = basicAppConfig.applicationId;
    const applicationId = appSettings?.id ?? app?.applicationId ?? staticApplicationId;
    const platform = basicAppConfig.platform;
    const mode = basicAppConfig.mode;
    const isPartnerApp = basicAppConfig.isPartnerApp;
    const applicationName = appSettings?.name;
    const searchClientSearchKey = appSettings?.typesenseSearchKey;
    const negativeKeywords = appSettings?.negativeWordsForSearch?.filters || [];
    const inferenceModels = appSettings?.inferenceModels || [];
    const avatarImageGeneration = appSettings?.avatarImageGeneration || EMPTY_AVATAR_IMAGE_GENERATION_CONFIG;
    const recombeeRecommendationsConfig = appSettings?.recombeeRecommendations;
    const typesenseConfig = appSettings?.typesenseConfig;
    const branding = appSettings?.branding;
    // eslint-disable-next-line custom/todo-format -- we do not have a ticket for this TODO
    // TODO (Stas Kochenkov): isNsfwEnabled should check ApplicationCapabilities, User NSFW switch, Age verification.
    // https://nexday-ai.atlassian.net/wiki/spaces/SD/pages/693207041
    const isNsfwEnabled = useApplicationCapabilitiesAllowed(CapabilityKey.Nsfw);
    const mobileApplications = appSettings?.mobileApplications;
    const logoutDomain = appSettings?.logoutDomain;
    const localization = appSettings?.localization;
    const { tags: chatbotTags = [], nsfw_tags: chatbotNsfwTags = [], priority_tags: chatbotPriorityTags = [] } = appSettings?.chatbotsTags || {};
    const { tags: lorebookTags = [], nsfw_tags: lorebookNsfwTags = [], priority_tags: lorebookPriorityTags = [] } = appSettings?.lorebookTags || {};
    const tagOptions = getTagOptions(chatbotTags, chatbotNsfwTags, chatbotPriorityTags);
    const lorebookTagOptions = getTagOptions(lorebookTags, lorebookNsfwTags, lorebookPriorityTags);
    const setUserApplicationId = (appId) => {
        dispatch(setApplicationId(appId));
    };
    const setApplicationIsPartner = (isPartner) => {
        dispatch(setIsPartner(isPartner));
    };
    return {
        applicationId,
        applicationName,
        searchClientSearchKey,
        negativeKeywords,
        inferenceModels,
        avatarImageGeneration,
        recombeeRecommendationsConfig,
        typesenseConfig,
        tagOptions,
        lorebookTagOptions,
        lastAppSettingUpdatedAt,
        branding,
        mobileApplications,
        logoutDomain,
        appSettings,
        setUserApplicationId,
        setApplicationIsPartner,
        isNsfwEnabled,
        isPartner,
        deviceType,
        localization,
        platform,
        mode,
        isPartnerApp,
    };
}
